import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';

import { GlobalTheme } from './../../theme';
import { Container, Typography, Box, Card, CardContent, CardMedia, Divider, Stack, Link } from '@mui/material';

import TablePagination from '@mui/material/TablePagination';
import { alpha } from '@mui/system';
import Grid from '@mui/material/Grid';

import TravelRequest from '../../components/navbar/travelRequest';

import DynamicMantle from './../../components/mantles/DynamicMantle';
import GoogleAnalytics from '../../components/gAnalytics/gAnalytics';

const BASE_MEDIA_URL = 'https://aaryanholidays.in/express/uploads/';

const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
        return text.substring(0, maxLength) + '...';
    }
    return text;
};

export default function TourListing() {
    const { refer_other_id } = useParams();
    const { continent } = useParams();
    const { country } = useParams();
    const navigate = useNavigate();
    const [tourListingData, setTourListingData] = useState([]);
    const [tourTypeData, setTourTypeData] = useState({ heading: '', desc_txt: '', banner_type: '', banner_src: '', banner_alt: '', banner_title: '', banner_description: '' });
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(8);
    const [isLoading, setIsLoading] = useState(true);
    const videoRefs = useRef([]);
    const [showContent, setShowContent] = useState(false);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const paginatedData = tourListingData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const handleMouseEnter = (index) => {
        const videoElement = videoRefs.current[index];
        if (videoElement && videoElement.paused) {
            videoElement.play().catch(error => console.error('Error playing video:', error));
        }
    };

    const handleMouseLeave = (index) => {
        const videoElement = videoRefs.current[index];
        if (videoElement && !videoElement.paused) {
            videoElement.pause();
            videoElement.currentTime = 0;
        }
    };
    const generateThumbnail = (videoSrc, callback) => {
        const video = document.createElement('video');
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        video.src = videoSrc;
        video.crossOrigin = 'anonymous'; // Handle CORS
        video.muted = true;
        video.playsInline = true;

        // When the video is loaded, draw the frame on the canvas and call the callback
        video.addEventListener('loadeddata', () => {
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataUrl = canvas.toDataURL('image/jpeg', 0.8); // Create a JPEG thumbnail
            callback(dataUrl); // Pass the thumbnail URL to the callback
        });

        video.addEventListener('error', (error) => {
            console.error('Error generating thumbnail:', error);
            callback(null); // Pass null if an error occurs
        });

        // Play and immediately pause to trigger 'loadeddata'
        video.play().then(() => {
            video.pause();
        });
    };

    // Function to close the dialog
    const openOfferDialog = () => {
        setShowContent(true); // Open the dialog
    };

    const closeOfferDIalog = () => {
        setShowContent(false); // Close the dialog
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowContent(true);
        }, 10000); // 10 seconds delay

        return () => clearTimeout(timer); // Cleanup the timer on component unmount
    }, []);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const [tourResponse, tourTypeResponse] = await Promise.all([
                    fetch(`https://aaryanholidays.in/frontend/destinations?tour_type_id=${refer_other_id}`),
                    fetch(`https://aaryanholidays.in/frontend/tour-types/${refer_other_id}`)
                ]);
                const tourData = await tourResponse.json();
                const tourTypeData = await tourTypeResponse.json();

                const processedData = await Promise.all(
                    tourData.map(async (tour) => {
                        if (tour.type === 'video') {
                            // Process video to generate a thumbnail
                            return new Promise((resolve) => {
                                generateThumbnail(`${BASE_MEDIA_URL}${tour.src}`, (thumbnail) => {
                                    resolve({ ...tour, thumbnail: thumbnail || null }); // Add thumbnail or null
                                });
                            });
                        } else {
                            // Non-video items are returned as-is
                            return { ...tour };
                        }
                    })
                );

                // Update state with the processed data
                setTourListingData(processedData);
                setTourTypeData(tourTypeData);
                setIsLoading(false);
                setPage(0);

                console.error(processedData);
                console.error(tourTypeData);
            } catch (error) {
                console.error('Error fetching data: ', error);
            }
        };

        fetchData();
    }, [refer_other_id]);


    const handleCardClick = (id, continent, country, tour) => {
        navigate(`/${continent}/${country}/${tour}/itenary/${id}`)
    }

    return (
        <React.Fragment>
            <Helmet>
                <title>{tourTypeData?.banner_title ? `${tourTypeData?.banner_title} - Aaryan Holidays` : ''}</title>
                <meta name="description" content={tourTypeData?.banner_description || ""} />
                <meta name="keywords" content={tourTypeData?.keyword || ""} />
                <meta property="og:title" content={tourTypeData?.banner_title || ""} />
                <meta property="og:description" content={tourTypeData?.banner_description || ""} />
                <meta property="og:url" content={`https://aaryanholidays.com/tour-type/4/${refer_other_id}`} />
                <meta property="og:image" content={`${BASE_MEDIA_URL}${tourTypeData?.banner_src}` || ""} />
            </Helmet>
            <ThemeProvider theme={GlobalTheme}>
                {/* {
                    showContent && <Offer open={showContent} handleClose={closeOfferDIalog} />
                } */}
                <CssBaseline />
                <DynamicMantle
                    banner_type={tourTypeData.banner_type}
                    banner_src={`${BASE_MEDIA_URL}${tourTypeData.banner_src}`}
                    banner_alt={tourTypeData.banner_alt}
                    banner_title={tourTypeData.banner_title}
                    banner_description={tourTypeData.banner_description}
                    openOfferDialog={openOfferDialog}
                    isLoading={isLoading}
                />

                <Container maxWidth="lg" sx={{ py: 5 }}>
                    <Grid textAlign='center'>
                        <Typography id="destinationHeading" component='h2' variant='h2' sx={{ mb: 2, display: 'block', width: '100%' }}>
                            {tourTypeData.heading}
                        </Typography>
                        {false && <Typography component='p'>
                            {tourTypeData.desc_txt}
                        </Typography>}
                    </Grid>

                    <Grid container spacing={4} id='tourListing' sx={{ mt: 2 }}>
                        {paginatedData.map((tour, index) => (
                            <Grid
                                item
                                id={`tourListing${tour.id}`}
                                key={tour.id}
                                xs={12}
                                sm={6}
                                md={4}
                                sx={{ display: 'inline-flex' }}
                            >
                                <Card
                                    sx={{
                                        position: 'relative',
                                        borderRadius: 2,
                                        width: { xs: '100%', sm: 367 },
                                        height: {
                                            xs: 468,
                                            sm: 500
                                        },
                                        objectFit: 'cover',
                                        overflow: 'hidden'
                                    }}>
                                    <Box
                                        id={'destinationListing' + tour.id}
                                        onMouseEnter={() => handleMouseEnter(index)}
                                        onMouseLeave={() => handleMouseLeave(index)}
                                        sx={{ height: 'inherit' }}
                                    >

                                        {tour.type === 'video' ? (
                                            <CardMedia
                                                id={`destinationThumbsVid${index}`}
                                                component="video"
                                                src={`${BASE_MEDIA_URL}${tour.src}`}
                                                poster={tour.thumbnail ? `${tour.thumbnail}` : undefined} // Show thumbnail as poster
                                                loop
                                                muted
                                                playsInline
                                                ref={(el) => (videoRefs.current[index] = el)}
                                                sx={{ height: 'inherit' }}
                                            >
                                                <source src={`${BASE_MEDIA_URL}${tour.src}`} type="video/mp4" />
                                                Your browser does not support the video tag.
                                            </CardMedia>
                                        ) : (
                                            <CardMedia
                                                id={`destinationThumbsImg${index}`}
                                                component="img"
                                                src={`${BASE_MEDIA_URL}${tour.src}`}
                                                alt={tour.alt}
                                                sx={{ height: '100%', objectFit: 'cover' }} // Maintain aspect ratio
                                                loading='lazy'
                                            />
                                        )}

                                        <CardContent
                                            component='span'
                                            sx={{
                                                position: 'absolute',
                                                bottom: 0,
                                                left: 0,
                                                textAlign: 'left',

                                                width: '100%',
                                                display: 'flex',
                                                flexDirection: { xs: 'row ', sm: 'column' },
                                                flexWrap: 'wrap',
                                                justifyContent: 'flex-end',
                                                height: { xs: 230, sm: 'inherit' },
                                                background: {
                                                    xs: alpha(GlobalTheme.palette.common.black, 0.8),
                                                    sm: `linear-gradient(0deg, ${alpha(GlobalTheme.palette.common.tertiary, .7)} 30%, ${alpha(GlobalTheme.palette.common.tertiary, 0)} 70%)`
                                                },
                                                transition: 'all .4s ease',
                                                // "&:hover": {
                                                //     pt: 23,
                                                //     background: `linear-gradient(0deg, ${alpha(GlobalTheme.palette.common.tertiary, .8)} 10%, ${alpha(GlobalTheme.palette.common.tertiary, 0)} 100%)`,
                                                // }
                                            }}>
                                            <Box component='span'>
                                                <Typography id={`tourDays${tour.id}`} component='p' variant="subtitle2" fontWeight={400} color='warning.light' gutterBottom>
                                                    {tour.tour_days}
                                                </Typography>
                                                <Typography id={`tourDesc${tour.id}`} component='p' variant="subtitle2" color='common.white' sx={{
                                                    textAlign: 'left',
                                                }} fontWeight={400}>
                                                    {truncateText(tour.banner_description, 90)}
                                                </Typography>
                                                <Typography variant='h3' component='h3' sx={{ color: GlobalTheme.palette.common.white, pr: 4 }} gutterBottom>
                                                    <span dangerouslySetInnerHTML={{ __html: tour.thumbnail_heading }} />
                                                </Typography>
                                                <Divider sx={{ backgroundColor: GlobalTheme.palette.common.white, mb: .5 }} />

                                                <Typography component='p' variant="subtitle1" color='common.white' sx={{ textAlign: 'left', display: 'flex', alignItems: 'center' }} >
                                                    INR {tour.price} <Typography component='span' fontWeight={400} variant='subtitle2'>&nbsp;per person</Typography>
                                                </Typography>
                                            </Box>

                                            <Stack component='span' width='100%' direction={{ xs: 'row', md: 'column', lg: 'row' }} justifyContent='space-between' sx={{ mt: 2 }} spacing={3}>
                                                <Link id={'btnTourPlp' + tour.id} variant="contained" underline='none'
                                                    href={`/${continent}/${country}/${tour.thumbnail_heading.replace(/\s+/g, '-')}/itenary/${tour.id}`}
                                                    // onClick={() => handleCardClick(tour.id, continent, country, tour.thumbnail_heading.replace(/\s+/g, '-'))}
                                                    sx={{
                                                        px: 2, py: 1.5, borderRadius: 2,
                                                        color: GlobalTheme.palette.common.white,
                                                        borderColor: GlobalTheme.palette.primary.main,
                                                        backgroundColor: GlobalTheme.palette.primary.main,

                                                        '&:hover, &:focus': {
                                                            color: GlobalTheme.palette.common.black,
                                                            borderColor: GlobalTheme.palette.common.white,
                                                            backgroundColor: GlobalTheme.palette.common.white,
                                                        }
                                                    }}>
                                                    View Tour
                                                </Link>

                                                <TravelRequest
                                                    id={`getQutBtn${tour.thumbnail_heading.substring(0, 2).replace(/\s+/g, '')}_${tour.id}_${Date.now()}`}
                                                    variant="outlined"
                                                    size='medium'
                                                    btnLabel='Get a Quote'
                                                    sxOverrides={{
                                                        py: .625, px: 1.875, borderRadius: 2,
                                                        color: GlobalTheme.palette.common.white,
                                                        borderColor: GlobalTheme.palette.primary.main,
                                                        backgroundColor: 'transparent',

                                                        '&:hover, &:focus': {
                                                            color: GlobalTheme.palette.primary.main,
                                                            backgroundColor: GlobalTheme.palette.common.white,
                                                        }

                                                    }}
                                                />
                                            </Stack>



                                            {/* <Typography variant='h3' component='h3' sx={{ color: GlobalTheme.palette.common.white, pr: 4 }} gutterBottom>
                                                <span dangerouslySetInnerHTML={{ __html: tour.thumbnail_heading }} />
                                            </Typography>

                                            <Typography component='h4' variant="subtitle2" sx={{ color: GlobalTheme.palette.common.white }}>
                                                {truncateText(tour.thumbnail_desc, 80)}
                                            </Typography> */}
                                        </CardContent>
                                    </Box>
                                </Card>
                            </Grid>
                        ))}

                    </Grid>
                    <Grid sx={{ mt: 3, display: 'block', px: 0 }}>
                        <TablePagination
                            component="div"
                            count={tourListingData.length}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            rowsPerPageOptions={[8, 16, 24]}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Grid>

                </Container>
                <GoogleAnalytics />
            </ThemeProvider>
        </React.Fragment >
    )
}
